import { Alert, AlertColor, Container, Paper, Snackbar } from '@mui/material'
import ContentTextTitle from 'components/ContentTextTitle/ContentTextTitle'
import LogoBrand from 'components/LogoBrand/LogoBrand'
import React, { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
// import logoImg from 'assets/images/logo.png'

export const AlertContext = React.createContext<{
  setAlert: React.Dispatch<
    React.SetStateAction<{
      message: string
      alertType: AlertColor
    }>
  >
}>({ setAlert: () => {} })

const Layout: React.FC = () => {
  const [alertData, setAlertData] = useState<{
    message: string
    alertType: AlertColor
  }>({
    message: '',
    alertType: 'error',
  })

  const location = useLocation()
  const { pathname } = location

  return (
    <div className="min-h-[100vh] bg-primary">
      <div className="min-h-[100vh]">
        <CustomSnackbar alertData={alertData} setAlertData={setAlertData} />
        <AlertContext.Provider value={{ setAlert: setAlertData }}>
          <Container maxWidth="sm" sx={{ pb: 7 }}>
            <LogoBrand />
            {/* {pathname.includes('thankyou') && (
              <ContentTextTitle
                title={`General Admission \n(Doors Open 30 Minutes before 10am)`}
                sx={{
                  color: '#f5ec90',
                  fontSize: '24px',
                  lineHeight: '34px',
                }}
              />
            )} */}

            <Paper
              elevation={0}
              sx={{
                mt: 1,
                p: 4.5,
              }}
            >
              <Outlet />
            </Paper>
          </Container>
        </AlertContext.Provider>
      </div>
    </div>
  )
}

const CustomSnackbar: React.FC<{
  alertData: {
    message: string
    alertType: AlertColor
  }
  setAlertData: React.Dispatch<
    React.SetStateAction<{
      message: string
      alertType: AlertColor
    }>
  >
}> = ({ alertData, setAlertData }) => {
  return (
    <Snackbar
      open={!!alertData.message}
      autoHideDuration={6000}
      onClose={() => {
        setAlertData((prev) => {
          return { ...prev, message: '' }
        })
      }}
      key={'topright'}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={() => {
          setAlertData((prev) => {
            return { ...prev, message: '' }
          })
        }}
        variant="filled"
        severity={alertData.alertType}
        sx={{ width: '100%' }}
      >
        {alertData.message}
      </Alert>
    </Snackbar>
  )
}

export default Layout
